import { Button, Form, Input, Modal, Select, notification } from 'antd';
import React from 'react';
import { Enums } from '../../../shared';
import { useTranslation } from 'react-i18next';
import { useIssueCommandMutation } from '../../../features/courses/coursesApi';

const ComponentCreateModal = ({ isOpen, onCancel }) => {
    const { t } = useTranslation();
    const [issueCommand, {}] = useIssueCommandMutation();

    const onOk = (values) => {
        const command = {
            type: Enums.COMMAND_TYPES.CREATE_COMPONENT,
            ...values,
        };

        issueCommand({
            command,
        })
            .unwrap()
            .then((res) => {
                notification.info({
                    message: t('workbench.lessons.notifications.lessonCreated'),
                    duration: 2,
                });
                onCancel();
            })
            .catch((err) => {
                notification.error({
                    message: t('workbench.lessons.notifications.lessonNotCreated'),
                    duration: 2,
                });
                onCancel();
            });
    };

    return (
        <Modal
            title={t('workbench.lessons.create.header')}
            open={isOpen}
            onOk={onOk}
            onCancel={onCancel}
            footer={null}
            width={1000}
        >
            <Form
                name="create-new-course-component"
                initialValues={{ remember: true }}
                onFinish={onOk}
                autoComplete="off"
                layout="vertical"
            >
                <Form.Item
                    label={t('workbench.lessons.create.title')}
                    name="title"
                    rules={[
                        {
                            required: true,
                            message: t('workbench.lessons.errors.titleMissing') as string,
                        },
                    ]}
                >
                    <Input data-cy="course-component-create-new-title" />
                </Form.Item>
                <Form.Item
                    label={t('workbench.lessons.create.description')}
                    name="description"
                    rules={[
                        {
                            required: true,
                            message: t('workbench.lessons.errors.descriptionMissing') as string,
                        },
                    ]}
                >
                    <Input.TextArea data-cy="course-component-create-new-description" />
                </Form.Item>
                <Form.Item>
                    <Button
                        data-cy="course-component-create-new-submit-button"
                        type="primary"
                        htmlType="submit"
                        style={{ float: 'right' }}
                    >
                        {t('create')}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ComponentCreateModal;
